export const JOTFORM_URL = "https://form.jotform.com/262451002702038";

export const PARTNER_FORM_URL = "https://form.jotform.com/262481768839071";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1561721632-a0d70ac1d15b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjB2aWRlbyUyMGVkaXRpbmclMjBzdHVkaW8lMjBkYXJrJTIwZmlsbSUyMGNhbWVyYXxlbnwwfHx8fDE3ODg2MTM0NDh8MA&ixlib=rb-4.1.0&q=85",
};
